import * as React from 'react'

const SvgSettingsAdjustIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 4.375h-3.188a3.125 3.125 0 00-6.124 0H1.25v1.25h8.188a3.125 3.125 0 006.124 0h3.188v-1.25zm-6.25 2.5a1.875 1.875 0 110-3.75 1.875 1.875 0 010 3.75zm-11.25 8.75h3.188a3.125 3.125 0 006.125 0h8.187v-1.25h-8.188a3.125 3.125 0 00-6.124 0H1.25v1.25zM5.625 15a1.875 1.875 0 113.75 0 1.875 1.875 0 01-3.75 0z"
      fill="#163250"
    />
  </svg>
)

export default SvgSettingsAdjustIcon
